import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface WhiteListQueryParams {
  page: number // 页码
  limit: number // 每页数量
  sort?: string // 排序规则
  asc?: boolean // 排序,true-正序，false-倒序
  key_word?: string // 搜索关键词
  popup_type: number // 弹窗类型,1-右下角弹泡，2-中间弹泡，3-捆绑软件
}

export interface WhiteListItem {
  soft_id: number // 软件id
  soft_name: string // 软件名称
  popup_type: number // 弹窗类型
}

@Injectable()
export class WhiteListViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  fetchWhiteList (options: WhiteListQueryParams) {
    return this.http
      .post<{
        total: number,
        list: WhiteListItem[]
      }>('/popupintercept/trust-list', options)
  }
}
